module.exports = __webpack_public_path__ + "static/1-b51b85a48a3ab592e7c08c5a46bfa4ef.png";